import { ShapeData } from 'data/FlyerData';
import { MASK_CHANGED } from 'state/actions';
import { getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

export class RemoveMaskCommand extends Command {
  layerId: string;
  previousMask: ShapeData;
  constructor(layerId: string) {
    super();
    this.layerId = layerId;
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      if (layer && layer.mask) {
        if (firstTime) {
          this.previousMask = layer.mask;
        }
        layer.setMask(null);
        // document.dispatchEvent(new Event(TEMPLATE_PROPERTY_CHANGED)); // To force render
        dispatch({
          type: MASK_CHANGED,
          layer
        });
      }
    };
  }
  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      if (layer) {
        layer.setMask(this.previousMask);
        // document.dispatchEvent(new Event(TEMPLATE_PROPERTY_CHANGED)); // To force render
        dispatch({
          type: MASK_CHANGED,
          layer
        });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/RemoveMaskCommand.ts